import React, { useEffect, useState } from "react";
import { useTrolley } from "../../context/TrolleyContext";

/* Illustrated rolling garden trolley — wheels turn with scroll, bounces on add. */
export const Trolley = () => {
  const { count, setOpen, pulse } = useTrolley();
  const [rot, setRot] = useState(0);
  const [bounce, setBounce] = useState(false);

  useEffect(() => {
    const onScroll = () => setRot(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!pulse) return;
    setBounce(true);
    const t = setTimeout(() => setBounce(false), 650);
    return () => clearTimeout(t);
  }, [pulse]);

  const wheel = (cx) => (
    <g style={{ transform: `rotate(${rot * 0.7}deg)`, transformOrigin: `${cx}px 86px` }}>
      <circle cx={cx} cy="86" r="13" fill="#4A1B4D" />
      <circle cx={cx} cy="86" r="5" fill="#FFD23F" />
      <rect x={cx - 1.4} y="74.5" width="2.8" height="23" rx="1.4" fill="#FDFBF7" />
      <rect x={cx - 11.5} y="84.6" width="23" height="2.8" rx="1.4" fill="#FDFBF7" />
    </g>
  );

  return (
    <button
      onClick={() => setOpen(true)}
      data-testid="trolley-button"
      aria-label={`Open your garden trolley — ${count} items`}
      className={`fixed bottom-6 right-5 md:bottom-8 md:right-8 z-40 group ${bounce ? "animate-trolley-bounce" : ""}`}
    >
      <div className="relative w-[96px] h-[88px] md:w-[116px] md:h-[106px] drop-shadow-[0_14px_24px_rgba(74,27,77,0.35)] transition-transform group-hover:-translate-y-1 group-hover:rotate-[-2deg]">
        <svg viewBox="0 0 120 104" className="w-full h-full">
          {/* handle */}
          <path d="M14 30 L4 12" stroke="#4A1B4D" strokeWidth="5" strokeLinecap="round" fill="none" />
          <circle cx="4" cy="11" r="5" fill="#EC2675" />
          {/* basket */}
          <path d="M12 32 L108 32 L100 72 L22 72 Z" fill="#EC2675" />
          <path d="M12 32 L108 32 L106 42 L14 42 Z" fill="#FFC2D1" />
          {/* scallop rim */}
          {[20, 34, 48, 62, 76, 90, 104].map((x) => (
            <circle key={x} cx={x} cy="32" r="6" fill="#FFC2D1" />
          ))}
          {/* little plants peeking out */}
          <g>
            <rect x="34" y="18" width="3.5" height="14" rx="1.7" fill="#1F8A50" />
            <circle cx="35.7" cy="15" r="6" fill="#FFD23F" />
            <circle cx="35.7" cy="15" r="2.4" fill="#FF7A3D" />
          </g>
          <g>
            <rect x="62" y="14" width="3.5" height="18" rx="1.7" fill="#146135" />
            <path d="M63.7 14 C58 10 58 4 63.7 2 C69.4 4 69.4 10 63.7 14" fill="#4ECDE9" />
          </g>
          <g>
            <rect x="84" y="20" width="3.5" height="12" rx="1.7" fill="#1F8A50" />
            <circle cx="85.7" cy="17" r="5" fill="#FF4F8B" />
            <circle cx="85.7" cy="17" r="2" fill="#FDFBF7" />
          </g>
          {wheel(34)}
          {wheel(88)}
        </svg>
        {count > 0 && (
          <span
            data-testid="trolley-count"
            className="absolute -top-1.5 -right-1.5 min-w-[28px] h-7 px-1.5 rounded-full bg-lemon text-plum-deep border-[3px] border-plum-deep text-sm font-bold flex items-center justify-center"
          >
            {count}
          </span>
        )}
      </div>
      <span className="block mt-1 text-center font-serif-display uppercase text-[9px] tracking-[0.2em] text-plum-deep/70 bg-cream/90 rounded-full px-2 py-0.5">
        YOUR TROLLEY
      </span>
    </button>
  );
};
